import ClearingAPI from '@shared/api';

export const {
    orders: { get: getMethods, putOrder, getAllOrders },
    securities: { getAllSecurities },
    accounts: { getAllAccounts },
} = ClearingAPI.settings;
